import { useEffect } from "react";
import { useNavigate } from "react-router";
import { useAuthRoles } from "@/entities/partner";
import { DEV_SKIP_AUTH } from "@/shared/lib/devAuthBypass";

function RouteSpinner() {
  return (
    <div className="grid h-screen place-content-center">
      <div className="h-8 w-8 animate-spin rounded-full border-b-2 border-purple-500"></div>
    </div>
  );
}

export function AdminRoute({ children }: { children: React.ReactNode }) {
  if (DEV_SKIP_AUTH) {
    return children;
  }
  return <RoleCheckedAdminRoute>{children}</RoleCheckedAdminRoute>;
}

function RoleCheckedAdminRoute({ children }: { children: React.ReactNode }) {
  const { isAdmin, isLoading } = useAuthRoles();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isLoading && !isAdmin) {
      navigate("/ask", { replace: true });
    }
  }, [isAdmin, isLoading, navigate]);

  if (isLoading || !isAdmin) {
    return <RouteSpinner />;
  }

  return children;
}
